import type { ReactNode } from 'react'

import clsx from 'clsx'

import { LAYOUT_IDS } from '../dom-ids'

type GameShellProps = {
  children: ReactNode
  className?: string
}

type GameShellSectionProps = {
  children: ReactNode
  className?: string
}

function Root({ children, className }: GameShellProps) {
  return (
    <div
      id={LAYOUT_IDS.shell}
      className={clsx(
        'layout-shell flex h-dvh flex-col overflow-hidden',
        className
      )}
    >
      {children}
    </div>
  )
}

function TopBar({ children, className }: GameShellSectionProps) {
  return (
    <div
      id={LAYOUT_IDS.topbar}
      className={clsx('shrink-0 overflow-visible', className)}
    >
      {children}
    </div>
  )
}

function Page({ children, className }: GameShellSectionProps) {
  return (
    <div
      className={clsx(
        'flex min-h-0 flex-1 flex-col overflow-hidden',
        className
      )}
    >
      {children}
    </div>
  )
}

function BottomNav({ children, className }: GameShellSectionProps) {
  /* Overlay de altura zero: a pílula é posicionada por `bottom` dentro do
     slot fixo. O conteúdo ocupa a viewport inteira e rola por baixo da barra.
     `z-bottom-nav` no slot garante que a barra e o leitor de QR fiquem acima
     do conteúdo da página. */
  return (
    <div
      id={LAYOUT_IDS.bottomNav}
      className={clsx(
        'fixed inset-x-0 bottom-0 z-bottom-nav flex h-0 shrink-0 items-stretch justify-center',
        className
      )}
    >
      {children}
    </div>
  )
}

export const GameShell = Object.assign(Root, { TopBar, Page, BottomNav })
